import React from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "../../../config/config.js";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCategorieSelected } from "../../../features/categorySlice.js";

import Card from "@mui/joy/Card";
import CardCover from "@mui/joy/CardCover";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";

const CardSport = ({ sport, typeDimension }) => {
  const navigate = useNavigate(); // Usa useNavigate para la redirección
  const { idevent } = useParams();
  const dispatch = useDispatch();

  const handleClick = () => {
    const fetchDatos = async () => {
      try {
        const eventFetch = await axios.get(
          `${API_BASE_URL}/championship/?idevent=${idevent}`
        );

        const sportFetch = await axios.get(
          `${API_BASE_URL}/sport/?idsport=${sport.idsport}`
        );

        // Despacha la acción para guardar los datos en el slice
        dispatch(
          setCategorieSelected({
            event: eventFetch.data,
            sport: sportFetch.data,
          })
        );

        // Redirigir a la ruta deseada
        navigate(
          `/campeonatos/${idevent}/list-categorias/${sport.idsport}/deporte`
        );
      } catch (error) {
        console.error("Error fetching datos", error);
      }
    };

    if (idevent && sport.idsport) {
      fetchDatos();
    }
  };

  const cardStyles = {
    minWidth: typeDimension === 1 ? 300 : 200,
    minHeight: typeDimension === 1 ? 150 : 300,
    flexGrow: 1,
    position: "relative",
    cursor: "pointer",
    overflow: "hidden", // Asegura que la imagen no se desborde del contenedor
    "&:hover img": {
      transform: "scale(1.1)", // Aplica el zoom
    },
  };


  return (
    <>
      <Card
        component="li"
        onClick={handleClick} // Añadir el controlador de clic
        // sx={{
        //   // minWidth: 300,
        //   // minHeight: 150,
        //   minWidth: 200,
        //   minHeight: 300,
        //   flexGrow: 1,
        //   position: "relative",
        //   cursor: "pointer",
        //   overflow: "hidden", // Asegura que la imagen no se desborde del contenedor
        //   "&:hover img": {
        //     transform: "scale(1.1)", // Aplica el zoom
        //   },
        // }}
        sx={cardStyles}
      >
        <CardCover>
          <img
            // src={sport.image_path}
            src={sport.displayImage || sport.image_path}
            loading="lazy"
            alt=""
            style={{
              transition: "transform 0.5s ease", // Transición suave para el zoom
            }}
          />
        </CardCover>
        <CardContent
          sx={{
            backgroundColor: "rgba(0, 0, 0, 0.61)", // Fondo negro semitransparente
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            padding: "8px",
          }}
        >
          <Typography
            level="body-lg"
            fontWeight="lg"
            textColor="#fff"
            textAlign="left"
          >
            {/* {sport.name} */}
            {sport.displayName || sport.name}
          </Typography>
        </CardContent>
      </Card>
    </>
  );
};

export default CardSport;
